import React from "react";
import './slider-regular-entire.scss';

import SliderComponent from "../slider-regular/slider-regular";

export default class SliderSectionComponent extends React.Component {

    constructor() {
        super();
        this.state = {
        }
    }

    componentDidMount(){

    }

    render(){
        return (
            <div className="slider-regular-entire" ref={this.component}>
                <div className="container">
                    <div className="column">
                        <div className="starts transition y-sync">
                            {[1,2,3,4,5].map((index) => 
                                <img key={index} src="https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542616/hp2021/general/star.svg" alt="#" />
                            )}
                        </div>
                        <p className="title extra-title--h2 transition y-sync">Why 30 million people love using Powtoon</p>
                    </div>
                    <div className="column">
                        <SliderComponent data={this.props.slider}></SliderComponent>
                    </div>
                </div>
            </div>
        );
    }
}